import { render, staticRenderFns } from "./Inspections.vue?vue&type=template&id=2ef1992f&scoped=true&"
import script from "./Inspections.vue?vue&type=script&lang=ts&"
export * from "./Inspections.vue?vue&type=script&lang=ts&"
import style0 from "./Inspections.vue?vue&type=style&index=0&id=2ef1992f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef1992f",
  null
  
)

export default component.exports